import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { useLanguage } from "../../contexts/LanguageContext";
import { SectionCTA } from "../shared/SectionCTA";

export const PainSection = () => {
  const { language, translations: t } = useLanguage();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  return (
    <section id="pain" className="py-20 md:py-28 bg-white scroll-mt-20" data-testid="pain-section" ref={ref}>
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2 className="font-['Heebo'] text-3xl md:text-4xl lg:text-5xl font-bold text-[#2C2C2C] mb-4">
            {t.pain.title}
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          {t.pain.items.map((point, i) => (
            <motion.div
              key={i}
              className="text-center p-8 rounded-2xl bg-[#FAF7F2] hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ delay: i * 0.08, duration: 0.5 }}
            >
              <div className="text-5xl mb-4">{["😔", "😤", "😞"][i]}</div>
              <h3 className="font-['Heebo'] text-xl font-bold text-[#2C2C2C] mb-2">{point.title}</h3>
              <p className="text-[#2C2C2C]/60">{point.desc}</p>
            </motion.div>
          ))}
        </div>

        <motion.p
          className="text-center mt-12 text-xl md:text-2xl text-[#2C2C2C]/80 font-medium"
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          transition={{ delay: 0.6 }}
        >
          {t.pain.cta}
        </motion.p>

        <SectionCTA text={language === 'he' ? "מוכנים לשינוי?" : "Ready for change?"} buttonText={language === 'he' ? "לייעוץ חינם" : "Free consultation"} />
      </div>
    </section>
  );
};
